import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import EN namespaces
import enCommon from './locales/en/common.json';
import enValidation from './locales/en/validation.json';
import enCreate from './locales/en/create.json';
import enBatch from './locales/en/batch.json';
import enPresets from './locales/en/presets.json';
import enExport from './locales/en/export.json';
import enAccessibility from './locales/en/accessibility.json';

// Import AR namespaces
import arCommon from './locales/ar/common.json';
import arValidation from './locales/ar/validation.json';
import arCreate from './locales/ar/create.json';
import arBatch from './locales/ar/batch.json';
import arPresets from './locales/ar/presets.json';
import arExport from './locales/ar/export.json';
import arAccessibility from './locales/ar/accessibility.json';

const resources = {
  en: {
    common: enCommon,
    validation: enValidation,
    create: enCreate,
    batch: enBatch,
    presets: enPresets,
    export: enExport,
    accessibility: enAccessibility,
  },
  ar: {
    common: arCommon,
    validation: arValidation,
    create: arCreate,
    batch: arBatch,
    presets: arPresets,
    export: arExport,
    accessibility: arAccessibility,
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already safe from xss
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'MamaQR-lang',
    },
  });

// Setup dynamic html attributes when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  localStorage.setItem('MamaQR-lang', lng);
});

